import { isFunction, isObject } from '@slardar/sdk-template';
export function getDefaultBrowser() {
    if (typeof window === 'object' && isObject(window))
        return window;
}
export function getDefaultDocument() {
    if (typeof document === 'object' && isObject(document))
        return document;
}
export function getDefaultLocation() {
    return getDefaultBrowser() && window.location;
}
export function getDefaultHistory() {
    return getDefaultBrowser() && window.history;
}
export function getDefaultPerformance() {
    if (getDefaultBrowser() && isObject(window.performance))
        return window.performance;
}
export function getDefaultPromise() {
    if (getDefaultBrowser() && 'Promise' in window)
        return Promise;
}
export function getDefaultXMLHttpRequest() {
    if (typeof XMLHttpRequest === 'function' && isFunction(XMLHttpRequest))
        return XMLHttpRequest;
}
export function getDefaultFetch() {
    try {
        new Headers();
        new Request('');
        new Response();
        return window.fetch;
    }
    catch (_a) {
        //
    }
}
export function getDefaultMutationObserver() {
    if (getDefaultBrowser() && isFunction(window.MutationObserver))
        return window.MutationObserver;
}
export function getDefaultPerformanceObserver() {
    if (getDefaultBrowser() && isFunction(window.PerformanceObserver))
        return window.PerformanceObserver;
}
export function getDefaultPerformanceTiming() {
    var performance = getDefaultPerformance();
    if (performance && isObject(performance.timing))
        return performance.timing;
}
export function getDefaultRaf() {
    if (getDefaultBrowser() && 'requestAnimationFrame' in window) {
        return window.requestAnimationFrame;
    }
}
export function getDefaultCaf() {
    if (getDefaultBrowser() && 'cancelAnimationFrame' in window) {
        return window.cancelAnimationFrame;
    }
}
export function getDefaultNavigator() {
    if (getDefaultBrowser() && 'navigator' in window) {
        return window.navigator;
    }
}
export function getDefaultNetworkInformation() {
    var navigator = getDefaultNavigator();
    if (navigator) {
        return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    }
}
//# sourceMappingURL=defaults.js.map